import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { api } from '../utils/api';

export const ChangePasswordPage: React.FC = () => {
  const { user, refreshUser, logout } = useAuth();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (!user) return <Navigate to="/login" replace />;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (newPassword.length < 6) {
      setError('A nova senha deve ter pelo menos 6 caracteres.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('A confirmação não confere.');
      return;
    }
    setSubmitting(true);
    try {
      await api.put('/auth/password', { currentPassword, newPassword });
      await refreshUser();
      // After refresh, user.mustChangePassword is false, so the role-based router takes over.
      if (user.role === 'partner') navigate('/parceiro', { replace: true });
      else if (user.role === 'seller') navigate('/vendedor', { replace: true });
      else if (user.role === 'admin') navigate('/admin', { replace: true });
      else if (user.role === 'maintenance_employee') navigate('/my-schedule', { replace: true });
      else navigate('/', { replace: true });
    } catch (err: any) {
      setError(err.response?.data?.error || 'Falha ao alterar senha.');
    } finally {
      setSubmitting(false);
    }
  };

  const forced = user.mustChangePassword === true;

  return (
    <div className="min-h-screen bg-orange-500 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8">
        <h1 className="text-2xl font-bold mb-2">
          {forced ? 'Defina sua nova senha' : 'Alterar senha'}
        </h1>
        {forced && (
          <p className="text-sm text-gray-600 mb-4">
            Para sua segurança, você precisa substituir a senha temporária antes de continuar.
          </p>
        )}
        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              {forced ? 'Senha temporária' : 'Senha atual'}
            </label>
            <input
              type="password"
              required
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Nova senha</label>
            <input
              type="password"
              required
              minLength={6}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Confirmar nova senha</label>
            <input
              type="password"
              required
              minLength={6}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            className="w-full px-4 py-3 bg-orange-600 text-white font-semibold rounded-lg hover:bg-orange-700 disabled:opacity-50"
          >
            {submitting ? 'Salvando…' : 'Alterar senha'}
          </button>
        </form>
        <button
          onClick={logout}
          className="mt-4 w-full text-sm text-gray-500 hover:text-gray-700"
        >
          Sair
        </button>
      </div>
    </div>
  );
};
